import { render, staticRenderFns } from "./MonitoringAIBudget.vue?vue&type=template&id=58d976dd&scoped=true&lang=pug"
import script from "./MonitoringAIBudget.vue?vue&type=script&lang=js"
export * from "./MonitoringAIBudget.vue?vue&type=script&lang=js"
import style0 from "./MonitoringAIBudget.vue?vue&type=style&index=0&id=58d976dd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d976dd",
  null
  
)

export default component.exports